//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { WebsiteBlockUpdateItem } from './WebsiteBlockUpdateItem';
import { WebsiteBlockReviewsType, WebsiteBlockType } from './Enums';

export class WebsiteBlockReviewsUpdateItem extends WebsiteBlockUpdateItem {
    Title?: string | null;
    TeacherIDs?: string[];
    ReviewsType: WebsiteBlockReviewsType = WebsiteBlockReviewsType.Default;
    override readonly WebsiteBlockType: WebsiteBlockType = WebsiteBlockType.Reviews;

    constructor(initializer?: Partial<Omit<WebsiteBlockReviewsUpdateItem, "WebsiteBlockType">>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static override readonly ClassName: string = "WebsiteBlockReviewsUpdateItem";
}
